// Fallback data for KnowHow GROUP
export const companyInfo = {
  name: "KnowHow GROUP",
  branch: "Privat investeringsvirksomhed",
  address: "Niels Jernes Vej 10, 9220 Aalborg Ø, Danmark",
  phone: "50 358 378",
  email: "info@knowhowgroup.dk",
  bank: "Danske Bank",
  mapCoordinates: { lat: 57.0125, lng: 9.9789 }
};

export const fallbackPages = {
  home: {
    page_slug: "home",
    title: "Forside",
    meta_title: "KnowHow GROUP",
    meta_description: "KnowHow GROUP er en privat investeringsvirksomhed med fokus på langsigtet værdiskabelse, strategiske investeringer og bæredygtig udvikling.",
    hero_title: "Vi investerer i fremtidens fundament",
    hero_text: "Mobil infrastruktur og energi. Aktiver med stabile cash flows og langsigtede kontrakter — essentielle uanset konjunktur.",
    content: `
      <h2>Om KnowHow GROUP</h2>
      <p>KnowHow GROUP er en privat investeringsvirksomhed med fokus på de sektorer, der bærer den moderne verden — mobil infrastruktur og energi.</p>
      <p>Vi søger ikke kortsigtede gevinster. Vi investerer i den fysiske rygrad, som digitalisering og energiomstilling bygger på.</p>
      <p>Vores team besidder dybt sektorkendskab og et netværk, der åbner døre, som ellers forbliver lukkede. Vi investerer egne midler og giver udvalgte medejere adgang til stærke, veldokumenterede projekter.</p>
      <p>KnowHow GROUP er ikke en fond, og vi er ikke en bank. Vi er investorer med specialiseret viden, langsigtede ambitioner og kapital, vi er villige til at sætte bag vores overbevisninger.</p>
      
      <h2>Sektorfokus</h2>
      <p>To sektorer. Uundværlig infrastruktur.</p>
      <ul>
        <li><strong>01 Mobil infrastruktur:</strong> Vi investerer i tårne, master og transmissionsanlæg, der driver den næste generation af konnektivitet. Efterspørgslen på digital infrastruktur vokser eksponentielt — KnowHow GROUP er positioneret til at drage fordel af denne strukturelle megatrend. (5G · Tårne · Transmission)</li>
        <li><strong>02 Energibranchen:</strong> Vores energiafdeling omfatter rådgivning inden for vedvarende energi, energilagring, strategisk indkøb og el-infrastruktur. Vi prioriterer aktiver med stabile, forudsigelige cash flows og langsigtede kontrakter — essentiel infrastruktur uanset konjunktur.</li>
      </ul>

      <h2>Investormodellen</h2>
      <p>Skin in the game som fundament</p>
      <p>Hos KnowHow GROUP er skin in the game ikke bare et udtryk — det er fundamentet for alt, hvad vi gør. Vi investerer altid egne penge i de projekter, vi præsenterer for andre. Det skaber et naturligt interessesammenfald og den form for tillid, som langsigtede relationer bygger på.</p>
      <ul>
        <li><strong>I Egne midler som anker:</strong> KnowHow GROUP investerer altid egenkapital som første kapital i hvert projekt. Intet projekt præsenteres for medejere, som vi ikke selv er med i.</li>
        <li><strong>II Plads til medejere:</strong> Udvalgte projekter åbner vi for medejerskab — typisk i en struktureret, overskuelig form, der giver reel eksponering uden unødig kompleksitet.</li>
        <li><strong>III Fokus på stabile aktiver:</strong> Vi prioriterer projekter med forudsigelige afkastprofiler og langsigtede kontrakter — infrastruktur, der er essentiel uanset konjunktur.</li>
      </ul>
    `,
    images: ["https://assets.auxodev.dk/assets/721a44a9-57f8-4fae-acca-66fa85e14172/modern-danish-office.jpg"]
  },
  "om-os": {
    page_slug: "om-os",
    title: "Om os",
    meta_title: "Om os - KnowHow GROUP",
    meta_description: "Læs mere om KnowHow GROUP, vores investeringsfilosofi og vores tilgang til langsigtet værdiskabelse.",
    hero_title: "Specialiseret viden. Langsigtet kapital.",
    hero_text: "KnowHow GROUP er en privat investeringsvirksomhed med fokus på de sektorer, der bærer den moderne verden — mobil infrastruktur og energi.",
    content: `
      <h2>Om KnowHow GROUP</h2>
      <p>KnowHow GROUP er en privat investeringsvirksomhed med fokus på de sektorer, der bærer den moderne verden — mobil infrastruktur og energi.</p>
      <p>Vi søger ikke kortsigtede gevinster. Vi investerer i den fysiske rygrad, som digitalisering og energiomstilling bygger på.</p>
      <p>Vores team besidder dybt sektorkendskab og et netværk, der åbner døre, som ellers forbliver lukkede. Vi investerer egne midler og giver udvalgte medejere adgang til stærke, veldokumenterede projekter.</p>
      <p>KnowHow GROUP er ikke en fond, og vi er ikke en bank. Vi er investorer med specialiseret viden, langsigtede ambitioner og kapital, vi er villige til at sætte bag vores overbevisninger.</p>
      
      <h2>Investormodellen</h2>
      <p>Skin in the game som fundament</p>
      <p>Hos KnowHow GROUP er skin in the game ikke bare et udtryk — det er fundamentet for alt, hvad vi gør. Vi investerer altid egne penge i de projekter, vi præsenterer for andre. Det skaber et naturligt interessesammenfald og den form for tillid, som langsigtede relationer bygger på.</p>
      <ul>
        <li><strong>I Egne midler som anker:</strong> KnowHow GROUP investerer altid egenkapital som første kapital i hvert projekt. Intet projekt præsenteres for medejere, som vi ikke selv er med i.</li>
        <li><strong>II Plads til medejere:</strong> Udvalgte projekter åbner vi for medejerskab — typisk i en struktureret, overskuelig form, der giver reel eksponering uden unødig kompleksitet.</li>
        <li><strong>III Fokus på stabile aktiver:</strong> Vi prioriterer projekter med forudsigelige afkastprofiler og langsigtede kontrakter — infrastruktur, der er essentiel uanset konjunktur.</li>
      </ul>
    `,
    images: ["https://assets.auxodev.dk/assets/721a44a9-57f8-4fae-acca-66fa85e14172/danish-boardroom.jpg"]
  },
  kontakt: {
    page_slug: "kontakt",
    title: "Kontakt",
    meta_title: "Kontakt - KnowHow GROUP",
    meta_description: "Kontakt KnowHow GROUP for dialog om investeringer, samarbejde og forretningsmuligheder.",
    hero_title: "Klar til en dialog?",
    hero_text: "Vi går altid i dialog med seriøse investorer, der deler vores langsigtede perspektiv. Er du interesseret i infrastruktur og energi som aktivklasse — og søger du stærke projekter med et naturligt interessesammenfald? Så vil vi gerne høre fra dig.",
    content: `
      <h2>Kontakt os</h2>
      <p>Vi går altid i dialog med seriøse investorer, der deler vores langsigtede perspektiv. Er du interesseret i infrastruktur og energi som aktivklasse — og søger du stærke projekter med et naturligt interessesammenfald? Så vil vi gerne høre fra dig.</p>
      <h3>Virksomhedsoplysninger</h3>
      <p>
        <strong>KnowHow GROUP</strong><br/>
        Niels Jernes Vej 10, 9220 Aalborg Ø, Danmark<br/>
        Telefon: 50 358 378<br/>
        E-mail: info@knowhowgroup.dk<br/>
        Bank: Danske Bank
      </p>
    `,
    images: ["https://assets.auxodev.dk/assets/721a44a9-57f8-4fae-acca-66fa85e14172/business-collaboration.jpg"]
  }
};
